import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import {
    TGridSchema,
    useFetch,
    useForm,
    useGrid,
    useModal,
    usePage,
    useResource,
    useStore,
    useTheme,
    useToast,
} from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import {
    APIS,
    labelConversionMap,
    SF_BTBDMS_MGMT_SRCH,
    SG_BTBDMS_MGMT_LIST_INIT,
    URLS,
} from "@/tz/go/egaz/osci/ptl/cmnty/btbdms/services/OsciBtbdmsService";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

/*
 * Common Bulletin board(Bulletin board message) List
 * !== 공통 게시판 (게시글) 목록 ==!
 */
export const OSCI0106001Q = (): JSX.Element => {
    const { t } = useTranslation();
    const modal = useModal();
    const navigate = useNavigate();
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0001", "auth_osci0002", "auth_osci0003"],
    });
    const toast = useToast();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const [bltbrdInfo, setBltbrdInfo] = useState<bltbrd>();
    const { theme } = useTheme();

    useResource({
        defaultSchema: [
            { area: "orgz" },
            { area: "cstmOfcrCd" },
            { area: "comnCd", comnCd: "OSC0162" },
            { area: "comnCd", comnCd: "OSC0096" },
        ],
    });

    const menuBoardMapList = [
        { menuId: "menu_osci0114", bltbrdId: "17835952-5e44-29f3-e063-020011ac31b7" }, //Q&A (MY PORTAL)
        { menuId: "menu_osci0144", bltbrdId: "14270d90-17af-e42d-e063-03001facae2d" }, //전체 공지사항(커뮤니티)
        { menuId: "menu_osci0112", bltbrdId: "14270d90-17af-e42d-e063-03001facae2d" }, //전체 공지사항 (MY PORTAL)
        { menuId: "menu_osci0113", bltbrdId: "17835952-5e49-29f3-e063-020011ac31b7" }, //자료실 (MY PORTAL)
        // { menuId: "menu_ptli0083", bltbrdId: "14270d90-17c3-e42d-e063-03001facae2d" }, //자료실(커뮤니티)
        { menuId: "menu_osci0145", bltbrdId: "17613ff3-47a2-7ebf-e063-020011acc580" }, //자료실(커뮤니티)
        { menuId: "menu_osci0116", bltbrdId: "17835952-5e4e-29f3-e063-020011ac31b7" }, //FAQ (MY PORTAL)
        // { menuId: "menu_ptli0085", bltbrdId: "14270d90-17c8-e42d-e063-03001facae2d" }, //FAQ(커뮤니티)
        { menuId: "menu_osci0147", bltbrdId: "17613ff3-47a7-7ebf-e063-020011acc580" }, //FAQ(커뮤니티)
        { menuId: "menu_osci0156", bltbrdId: "1860dd0c-b283-7cde-e063-020011ac3197" }, //템플릿 관리
        // { menuId: "menu_osci0169", bltbrdId: "17613ff3-479d-7ebf-e063-020011acc580" }, //Q&A(PORTAL)
        { menuId: "menu_osci0169", bltbrdId: "14270d90-17be-e42d-e063-03001facae2d" }, //Q&A(PORTAL)

        // { menuId: "menu_ptli0007", bltbrdId: "14270d90-17cd-e42d-e063-03001facae2d" }, //전자민원 처리
        // { menuId: "menu_ptli0013", bltbrdId: "153f6a94-796f-4255-e063-03001fac2587" }, //전체 공지사항(mypage)
        // { menuId: "menu_ptli0014", bltbrdId: "153f6a94-7974-4255-e063-03001fac2587" }, //개별 공지사항(mypage)
        // { menuId: "menu_ptli0015", bltbrdId: "153f6a94-7979-4255-e063-03001fac2587" }, //정부 공지사항(mypage)
        // { menuId: "menu_ptli0016", bltbrdId: "153f6a94-797e-4255-e063-03001fac2587" }, //Q&A(mypage)
        // { menuId: "menu_ptli0017", bltbrdId: "153f6a94-7983-4255-e063-03001fac2587" }, //자료실(mypage)
        // { menuId: "menu_ptli0020", bltbrdId: "153f6a94-7988-4255-e063-03001fac2587" }, //FAQ(mypage)
        // { menuId: "menu_ptli0080", bltbrdId: "14270d90-17b4-e42d-e063-03001facae2d" }, //개별 공지사항(커뮤니티)
        // { menuId: "menu_ptli0081", bltbrdId: "14270d90-17b9-e42d-e063-03001facae2d" }, //정부 공지사항(커뮤니티)
        // { menuId: "menu_ptli0124", bltbrdId: "153f6a94-7979-4255-e063-03001fac2587" }, //정부 공지사항(커뮤니티)
        // { menuId: "menu_ptli0323", bltbrdId: "2dc5aeb8-464f-2d48-e063-060011acac47" }, //서비스 요청(SR)
    ];

    const bltbrdId = (() => {
        for (const item of menuBoardMapList) {
            if (item.menuId === menuId) {
                return item.bltbrdId;
            }
        }
    })();

    // const queryParams = new URLSearchParams(location.search);
    // const bltbrdId = queryParams.get('bltbrdId');
    const lang = theme.lang;

    // Bulletin board Interface !== 게시판 ==!
    interface bltbrd {
        bltbrdId: string;
        bltbrdKorNm: string;
        bltbrdEngNm: string;
        bltbrdTzNm: string;
        btbdrpUseYn: string;
        btbdcmUseYn: string;
        btbdrpBtbdcmUseYn: string;
        ppupSettPsblYn: string;
        atcmUseYn: string;
        atcmUpldLmtNo: Number;
        atcmCapcLmtYn: string;
        atcmLmtCapc: number;
        secrtBtbdmsUseYn: string;
        selcCntUseYn: string;
        btbdmsSelcExuseYn: string;
        btbdrpSelcExuseYn: string;
        btbdrpSttsUseYn: string;
        relaBltbrdUseYn: string;
        btbdmsTpCdValList: any;
        reLaBltbrdList: any;
    }

    const form = {
        bltbrdSrch: useForm({
            defaultSchema: SF_BTBDMS_MGMT_SRCH,
            defaultValues: {
                ...pgeStore?.form,
                regstSrchStrtDt: comnUtils.getDate({ m: -1 }),
                regstSrchEndDt: comnUtils.getDate(),
            },
        }),
    };

    const grid = {
        bltbrdList: useGrid({
            defaultSchema: SG_BTBDMS_MGMT_LIST_INIT,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // get Bulletin board Management Information !== 게시판 관리 정보 조회==!
        getBltbrdInfo: useFetch({
            api: () => APIS.getBltbrdInfo(bltbrdId),
            onSuccess: (data: any) => {
                const apiBrdInfo = data.bltbrdInfo.content;
                // Managing bulletin board management information as state !== 게시판 관리정보 State로 관리 ==!
                setBltbrdInfo({
                    bltbrdId: apiBrdInfo.bltbrdId,
                    bltbrdKorNm: apiBrdInfo.bltbrdKorNm,
                    bltbrdEngNm: apiBrdInfo.bltbrdEngNm,
                    bltbrdTzNm: apiBrdInfo.bltbrdTzNm,
                    btbdrpUseYn: apiBrdInfo.btbdrpUseYn,
                    btbdcmUseYn: apiBrdInfo.btbdcmUseYn,
                    btbdrpBtbdcmUseYn: apiBrdInfo.btbdrpBtbdcmUseYn,
                    ppupSettPsblYn: apiBrdInfo.ppupSettPsblYn,
                    atcmUseYn: apiBrdInfo.atcmUseYn,
                    atcmUpldLmtNo: apiBrdInfo.atcmUpldLmtNo,
                    atcmCapcLmtYn: apiBrdInfo.atcmCapcLmtYn,
                    atcmLmtCapc: apiBrdInfo.atcmLmtCapc,
                    secrtBtbdmsUseYn: apiBrdInfo.secrtBtbdmsUseYn,
                    selcCntUseYn: apiBrdInfo.selcCntUseYn,
                    btbdmsSelcExuseYn: apiBrdInfo.btbdmsSelcExuseYn,
                    btbdrpSelcExuseYn: apiBrdInfo.btbdrpSelcExuseYn,
                    btbdrpSttsUseYn: apiBrdInfo.btbdrpSttsUseYn,
                    relaBltbrdUseYn: apiBrdInfo.relaBltbrdUseYn,
                    btbdmsTpCdValList: apiBrdInfo.bltbrdTpCdList,
                    reLaBltbrdList: apiBrdInfo.reLaBltbrdList,
                });

                handler.setSrchForm(apiBrdInfo);
                handler.setGridSchema(apiBrdInfo);
                fetch.getBtbdmsList.fetch();
            },
            // Invalid Bulletin UUID Return !== 유효하지 않은 게시판 UUID 리턴 ==!
            onError: () => {
                modal.openModal({
                    content: "msg.osc.00201", // Abnormal access. !== 비정상 접근입니다. ==!
                    onCancel: () => history.back(),
                });
            },
        }),

        // get List Of Bulletin board Message !== 게시글 목록 조회==!
        getBtbdmsList: useFetch({
            api: (page = grid.bltbrdList.page) =>
                APIS.getBtbdmsList(form.bltbrdSrch.getValues(), bltbrdId, page, grid.bltbrdList.size),
            enabled: comnUtils.isEmpty(form.bltbrdSrch.errors),
            key: [grid.bltbrdList.page, grid.bltbrdList.size],
            onSuccess: (data) => {
                console.log(data);
                data.btbdmsList.content.map((obj: any) => {
                    obj.btbdmsTpCdValList.map((innerObj: any) => {
                        if (innerObj.uprCdVldVal === "0") {
                            obj[`btbdmsTpCd-${innerObj.btbdmsTpCd}`] = innerObj.btbdmsTpCdValNm
                                ? innerObj.btbdmsTpCdValNm
                                : innerObj.btbdmsTpCdVal;
                        }
                    });
                });
                setStore(pgeUid, {
                    form: form.bltbrdSrch.getValues(),
                    page: grid.bltbrdList.page,
                    size: grid.bltbrdList.size,
                });
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.osc.00043" }); // Failed to select. !== 조회가 실패하였습니다. ==!
            },
        }),
    };

    const handler = {
        // change search form schema !== search form schema 변경 ==!
        setSrchForm: (apiBrdInfo: any) => {
            if (!comnUtils.isEmpty(apiBrdInfo.bltbrdTpCdList)) {
                if (
                    [
                        "14270d90-17cd-e42d-e063-03001facae2d",
                        "153f6a94-797e-4255-e063-03001fac2587",
                        "14270d90-17be-e42d-e063-03001facae2d",
                    ].includes(apiBrdInfo.bltbrdId)
                ) {
                    form.bltbrdSrch.setSchema("reffKey", {
                        type: "text",
                        label: "L_REFF_KEY",
                    });
                }
                apiBrdInfo.bltbrdTpCdList.forEach((obj: any) => {
                    const isCode = obj.btbdmsTpCdValList[0]?.usrDefnVldVal1?.includes("_");
                    form.bltbrdSrch.setSchema(`btbdmsTpCd-${obj.btbdmsTpCd}`, {
                        label:
                            labelConversionMap.find((item) => item.comnCd === obj.usrDefnVldVal1)?.label ||
                            obj.btbdmsTpCdNm,
                        type: "select",
                        ...(!isCode && {
                            options: obj.btbdmsTpCdValList.map((innerObj: any) => ({
                                label: innerObj.cdVldValNm,
                                value: innerObj.cdVldVal,
                            })),
                        }),
                        ...(obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_CSTM_ORGZ_M" && {
                            area: "orgz",
                            type: "code",
                            label: "L_CSTM_SCTN",
                        }),
                        ...(obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_USR_M" && {
                            area: "cstmOfcrCd",
                            type: "code",
                            label: "L_CHPN",
                        }),
                    });
                });
            }
            if ("14270d90-17af-e42d-e063-03001facae2d" === apiBrdInfo.bltbrdId) {
                if (menuId !== "menu_osci0144") {
                    setBltbrdInfo((prev) => {
                        if (!prev) return prev;
                        return {
                            ...prev,
                            btbdmsSelcExuseYn: "Y",
                            bltbrdKorNm: t("T_GNRL_ANOCMT"),
                            bltbrdEngNm: t("T_GNRL_ANOCMT"),
                            bltbrdTzNm: t("T_GNRL_ANOCMT"),
                        };
                    });
                }
            } else if ("14270d90-17af-e42d-e063-03001facae2d" === apiBrdInfo.bltbrdId) {
            }
        },

        // Create Grid Schema Dynamic !== 그리드 스키마 동적 생성 ==!
        setGridSchema: (apiBrdInfo: any) => {
            const SG_BTBDMS_MGMT_LIST_NEW: TGridSchema = {
                id: "grid_btbdmsMgmt",
                options: { pagination: "out", edit: false, index: true },
                head: [
                    { cells: [{ header: "L_BTBDMS_TTLE_NM", binding: "btbdmsTtleNm", width: "*" }] },
                    { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "*" }] },
                    { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "*" }] },
                ],
                body: [
                    { cells: [{ binding: "btbdmsTtleNm", align: "left" }] },
                    { cells: [{ binding: "frstRegstId" }] },
                    { cells: [{ binding: "frstRgsrDtm", type: "datetime" }] },
                ],
            };

            if (apiBrdInfo.selcCntUseYn && apiBrdInfo.selcCntUseYn === "Y") {
                SG_BTBDMS_MGMT_LIST_NEW.head.splice(1, 0, {
                    cells: [{ header: "L_SELC_CNT", binding: "selcCnt", width: "*" }],
                });
                SG_BTBDMS_MGMT_LIST_NEW.body.splice(1, 0, { cells: [{ binding: "selcCnt" }] });
            }

            if (apiBrdInfo.ppupSettPsblYn && apiBrdInfo.ppupSettPsblYn === "Y") {
                let ppupHeaderName =
                    bltbrdId === "1860dd0c-b283-7cde-e063-020011ac3197" ? "L_PUBL_FILE_YN" : "L_PPUP_YN";
                SG_BTBDMS_MGMT_LIST_NEW.head.splice(1, 0, {
                    cells: [{ header: ppupHeaderName, binding: "ppupYn", width: "*" }],
                });
                SG_BTBDMS_MGMT_LIST_NEW.body.splice(1, 0, { cells: [{ binding: "ppupYn" }] });
            }
            if (apiBrdInfo.btbdrpSttsUseYn && apiBrdInfo.btbdrpSttsUseYn === "Y") {
                SG_BTBDMS_MGMT_LIST_NEW.head.splice(1, 0, {
                    cells: [{ header: "L_POST_STTS", binding: "btbdrpSttsCd", width: "*" }],
                });
                SG_BTBDMS_MGMT_LIST_NEW.body.splice(1, 0, {
                    cells: [
                        { binding: "btbdrpSttsCd", type: "code", area: "comnCd", viewType: "label", comnCd: "OSC0162" },
                    ],
                });
            }
            if (!comnUtils.isEmpty(apiBrdInfo.bltbrdTpCdList)) {
                apiBrdInfo.bltbrdTpCdList.map((obj: any, index: number) => {
                    let headerName =
                        labelConversionMap.find((item) => item.comnCd === obj.usrDefnVldVal1)?.label ||
                        obj.btbdmsTpCdNm;
                    if (obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_CSTM_ORGZ_M") {
                        headerName = "L_CSTM_SCTN";
                    }
                    if (obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_USR_M") {
                        headerName = "L_CHPN";
                    }
                    SG_BTBDMS_MGMT_LIST_NEW.head.splice(1, 0, {
                        cells: [{ header: headerName, binding: `btbdmsTpCd-${obj.btbdmsTpCd}`, width: "*" }],
                    });
                    SG_BTBDMS_MGMT_LIST_NEW.body.splice(1, 0, {
                        cells: [
                            {
                                binding: `btbdmsTpCd-${obj.btbdmsTpCd}`,
                                ...(obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_CSTM_ORGZ_M" && {
                                    area: "orgz",
                                    type: "code",
                                    viewType: "label",
                                }),
                                ...(obj.btbdmsTpCdValList[0]?.usrDefnVldVal1 === "COMI_USR_M" && {
                                    type: "code",
                                    area: "cstmOfcrCd",
                                    viewType: "label",
                                }),
                            },
                        ],
                    });
                });
            }
            // For electronic complaints / Q&A, add a unique list of keys that the user can recognize 2024/07/31
            // !== 전자민원 / Q&A 인 경우, 사용자가 인지할수 있는 고유 키 list 표출 2024/07/31 추가 ==!
            if (
                [
                    "14270d90-17cd-e42d-e063-03001facae2d",
                    "153f6a94-797e-4255-e063-03001fac2587",
                    "14270d90-17be-e42d-e063-03001facae2d",
                ].includes(apiBrdInfo.bltbrdId)
            ) {
                SG_BTBDMS_MGMT_LIST_NEW.head.splice(0, 0, {
                    cells: [{ header: "L_REFF_KEY", binding: "reffKey", width: "*" }],
                });
                SG_BTBDMS_MGMT_LIST_NEW.body.splice(0, 0, {
                    cells: [{ binding: "reffKey" }],
                });
            }
            // For SR bulletin board, list of approval status will be displayed on February 12, 2025
            // !== SR 게시판 인 경우, 결재상태 list 표출 2025/02/12 추가 ==!
            if (["2dc5aeb8-464f-2d48-e063-060011acac47"].includes(apiBrdInfo.bltbrdId)) {
                SG_BTBDMS_MGMT_LIST_NEW.head.splice(2, 0, {
                    cells: [{ header: "L_APRV_STAT_CD", binding: "aprvStatCd", width: "*" }],
                });
                SG_BTBDMS_MGMT_LIST_NEW.body.splice(2, 0, {
                    cells: [{ binding: "aprvStatCd", type: "code", area: "comnCd", comnCd: "OSC0096" }],
                });
            }
            SG_BTBDMS_MGMT_LIST_NEW.head.push({ show: false, cells: [{ binding: "bltbrdId" }] });
            grid.bltbrdList.setSchema(SG_BTBDMS_MGMT_LIST_NEW);
        },
        onSrchBtnClick: () => {
            grid.bltbrdList.setPage(0);
            fetch.getBtbdmsList.fetch(0);
        },
        onMenuNewBtnClick: () => {
            navigate(`${URLS.osci0106003s}/${bltbrdId}?menuId=${menuId}`);
        },
        grid_bltbrdDtl: (data: any) => {
            navigate(
                `${URLS.osci0106002q}/${bltbrdId}/${data.btbdmsId}?menuId=${menuId}${
                    bltbrdInfo?.btbdrpUseYn === "Y" ? "&rpSize=" + data.rpSize : ""
                }`,
            );
        },
        onClear: () => {
            form.bltbrdSrch.clearValues();
            form.bltbrdSrch.setValues({
                btbdmsTtleNm: "",
                regstSrchStrtDt: comnUtils.getDate({ m: -1 }),
                regstSrchEndDt: comnUtils.getDate(),
            });
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_bltbrdList: {
            cell: {
                btbdmsTtleNm: (props: any) => {
                    const { rowValues, value } = props;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                handler.grid_bltbrdDtl(rowValues);
                            }}
                        >
                            {value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        fetch.getBltbrdInfo.fetch();
    }, []);

    useEffect(() => {
        form.bltbrdSrch.reset();
        fetch.getBltbrdInfo.fetch();
    }, [menuId]);

    useEffect(() => {
        fetch.getBltbrdInfo.fetch();
    }, [theme]);

    return (
        <Page
            title={
                bltbrdInfo &&
                (lang === "ko"
                    ? bltbrdInfo.bltbrdKorNm
                    : lang === "en"
                      ? bltbrdInfo.bltbrdEngNm
                      : lang === "tz"
                        ? bltbrdInfo.bltbrdTzNm
                        : "")
            }
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.bltbrdSrch.schema.btbdmsTtleNm} />
                            <Group.Control {...form.bltbrdSrch.schema.frstRgsrDtmRnge} />
                        </Group.Row>
                        {bltbrdInfo &&
                            ([
                                "14270d90-17cd-e42d-e063-03001facae2d",
                                "153f6a94-797e-4255-e063-03001fac2587",
                                "14270d90-17be-e42d-e063-03001facae2d",
                            ].includes(bltbrdInfo.bltbrdId) ||
                                bltbrdInfo.btbdrpSttsUseYn === "Y") && (
                                <Group.Row>
                                    {[
                                        "14270d90-17cd-e42d-e063-03001facae2d",
                                        "153f6a94-797e-4255-e063-03001fac2587",
                                        "14270d90-17be-e42d-e063-03001facae2d",
                                    ].includes(bltbrdInfo.bltbrdId) && (
                                        <Group.Control {...form.bltbrdSrch.schema.reffKey} />
                                    )}
                                    {bltbrdInfo.btbdrpSttsUseYn === "Y" && (
                                        <Group.Control {...form.bltbrdSrch.schema.btbdrpSttsCd} />
                                    )}
                                </Group.Row>
                            )}
                        {bltbrdInfo && bltbrdInfo.btbdmsTpCdValList && (
                            <>
                                {bltbrdInfo.btbdmsTpCdValList.map(
                                    (obj: any, index: any) =>
                                        index % 2 === 0 && (
                                            <Group.Row key={index}>
                                                {" "}
                                                {/* Use index %2 to hold two each !== 2개씩 담기 위해 index % 2를 사용 ==!*/}
                                                <>
                                                    <Group.Control
                                                        {...form.bltbrdSrch.schema[`btbdmsTpCd-${obj.btbdmsTpCd}`]}
                                                    />
                                                    {/* Add a new control if you have the following controls !== 다음 Control이 있으면 새로운 Control을 추가 ==!*/}
                                                    {index + 1 < bltbrdInfo.btbdmsTpCdValList.length && (
                                                        <Group.Control
                                                            {...form.bltbrdSrch.schema[
                                                                `btbdmsTpCd-${
                                                                    bltbrdInfo.btbdmsTpCdValList[index + 1].btbdmsTpCd
                                                                }`
                                                            ]}
                                                        />
                                                    )}
                                                </>
                                            </Group.Row>
                                        ),
                                )}
                            </>
                        )}
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => handler.onClear()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.onSrchBtnClick} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.bltbrdList.grid}
                            data={fetch.getBtbdmsList.data?.btbdmsList}
                            render={render.grid_bltbrdList}
                            // onCellClick={handler.grid_bltbrdDtl}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
            {bltbrdInfo && bltbrdInfo.btbdmsSelcExuseYn !== "Y" && (
                <Layout>
                    <Layout.Left>
                        <Layout.Button role={"new"} onClick={handler.onMenuNewBtnClick} />
                    </Layout.Left>
                </Layout>
            )}
        </Page>
    );
};
